import React from 'react'
import { styled } from 'mz-ui-kit'
import { FormattedMessage } from 'mz-intl'

const ErrorMessageWrapper = styled('div', ({ $palette }) => ({
  color: `${$palette('RED')}`,
}))

const ErrorMessage = ({ errorMessage }) => (
  <FormattedMessage message={errorMessage} tagName={ErrorMessageWrapper} />
)

export default ErrorMessage
